export const links = [
  { name: 'Nosotros', path: '/about', id: 1 },
  { name: 'Servicios', path: '/#services', id: 2 },
  { name: 'Warrants', path: '/warrants', id: 3 },
  { name: 'Contacto', path: '/contact', id: 4 },
]
